<script setup lang="ts">
import RivePreview from '@shared/components/Rive/RivePreview.vue'
import riveUrl from './giftly_logo.riv?url'
import GiftlyLogoSvg from './GiftlyLogoSvg.vue'
import GiftlyLogoChristmasSvg from './GiftlyLogoChristmasSvg.vue'

const currentTheme = inject('currentTheme')
const isHolidays = computed(() => currentTheme === 'holidays')
</script>

<template>
  <div class="giftly-logo" style=" height: 50px; width: 100px;">
    <RivePreview
      v-if="isHolidays"
      :riveUrl="riveUrl"
      stateMachine="mainSM"
      artboard="mainArtboard"
      href="/"
      aria-label="Giftly home"
    >
      <!-- In SSR render the logo without the hat so that the hat doesn't jump when rendering the client -->
      <template #ssr>
        <GiftlyLogoSvg/>
      </template>

      <!-- When rive is loading (client side) show the logo without the hat -->
      <template #loading>
        <GiftlyLogoSvg/>
      </template>

      <!-- If Rive fails, show the logo with the hat -->
      <template #loadFailed>
        <GiftlyLogoChristmasSvg/>
      </template>

      <!-- Used for users with motion disabled at system level -->
      <template #fallback>
        <GiftlyLogoChristmasSvg/>
      </template>
    </RivePreview>
    <a v-else href="/" aria-label="Giftly home">
      <GiftlyLogoSvg/>
    </a>
  </div>
</template>
